/**
 * Behaviour Module Constants
 */

import { Briefcase, BookText, BookOpenCheck, Laugh } from 'lucide-react';
import type { RadioTabOption } from './types';
import Thorough from '/assets/behaviour/text-thorough.svg';
import Standard from '/assets/behaviour/text-standard.svg';
import Concise from '/assets/behaviour/text-concise.svg';

export const TONE_OPTIONS: RadioTabOption[] = [
  { label: 'Professional', value: 'professional', icon: Briefcase, description: 'Clear, respectful, and authoritative communication' },
  { label: 'Neutral', value: 'neutral', icon: BookText, description: 'Clear, respectful, and authoritative communication' },
  { label: 'Friendly', value: 'friendly', icon: Laugh, description: 'Clear, respectful, and authoritative communication' },
  { label: 'Matter-of-Fact', value: 'matter-of-fact', icon: BookOpenCheck, description: 'Clear, respectful, and authoritative communication' }
];

export const ANSWER_LENGTH_OPTIONS: RadioTabOption[] = [
  { label: 'Thorough', value: 'thorough', icon: Thorough, description: 'Clear, respectful, and authoritative communication' },
  { label: 'Standard', value: 'standard', icon: Standard, description: 'Clear, respectful, and authoritative communication' },
  { label: 'Concise', value: 'concise', icon: Concise, description: 'Clear, respectful, and authoritative communication' }
];

export const CHANNEL_ICONS = {
  email: {
    active: '/assets/knowledge-bases/mail-active.svg',
    inactive: '/assets/knowledge-bases/mail-inactive.svg'
  },
  social: {
    active: '/assets/knowledge-bases/social-active.svg',
    inactive: '/assets/knowledge-bases/social-inactive.svg'
  },
  sms: {
    active: '/assets/knowledge-bases/sms-active.svg',
    inactive: '/assets/knowledge-bases/sms-inactive.svg'
  },
  chat: {
    active: '/assets/knowledge-bases/chat-active.svg',
    inactive: '/assets/knowledge-bases/chat-inactive.svg'
  }
} as const;

export const DEFAULT_BEHAVIOUR_PLACEHOLDER =
  'e.g. Be professional, and empathetic, addressing the sender by name and acknowledging their specific question or concern.';
